module.exports = __webpack_public_path__ + "static/media/bg_hero.b97e69dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/hrtable/bg_hero.jpg
// module id = 84
// module chunks = 19